import * as React from "react"
import {
  Text,
  HStack,
  useColorMode,
} from "@chakra-ui/react"

// Main Logo component
export const Logo = React.forwardRef<HTMLDivElement, any>((props, ref) => {
  const { colorMode } = useColorMode();

  return (
    <HStack
      ref={ref}
      spacing={0}
      align="baseline"
      {...props}
    >
      <Text
        fontSize={{ base: "lg", md: "xl" }}
        fontWeight="800"
        color={colorMode === 'light' ? "#1E3A5F" : "#4A90D9"}
        letterSpacing="-0.03em"
        whiteSpace="nowrap"
        fontFamily="-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans SC', 'PingFang SC', system-ui, sans-serif"
      >
        Link
      </Text>
      <Text
        fontSize={{ base: "lg", md: "xl" }}
        fontWeight="700"
        color={colorMode === 'light' ? "#2563EB" : "#BFDBFE"}
        letterSpacing="-0.03em"
        whiteSpace="nowrap"
        fontFamily="-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans SC', 'PingFang SC', system-ui, sans-serif"
      >
        OSx
      </Text>
    </HStack>
  )
})

Logo.displayName = 'Logo'

export default Logo;
